import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useRouter } from 'next/router'
import { FormattedMessage } from 'react-intl'
import Typography from '../../atoms/typography'
import DynamicAreas from '../../particles/dynamic-areas'
import dynamic from 'next/dynamic'
import { useUserCountry } from '@bluheadless/ui-logic/src/hooks/user-country'
import Head from 'next/head'

const StoreLocator = dynamic(() => import('../../organisms/store-locator'))
const StoreLocatorBaidu = dynamic(() => import('../../organisms/store-locator').then((mod) => mod.StoreLocatorBaidu))
const StoreLocatorGrid = dynamic(() => import('../../organisms/store-locator').then((mod) => mod.StoreLocatorGrid))
const StoreLocatorColumns = dynamic(() =>
	import('../../organisms/store-locator').then((mod) => mod.StoreLocatorColumns)
)

const StoreLocatorPageComponent = ({ dynamicAreas }) => {
	const router = useRouter()
	const { country: userCountry } = useUserCountry()
	const {
		query: { lat, lng, store },
	} = router

	const {
		storelocator: { template },
		baidu: { enabled: baiduEnabled },
	} = useConfig()

	const getStoreLocatorContent = (template) => {
		switch (template) {
			case 'grid':
				return <StoreLocatorGrid />
			case 'map':
				return baiduEnabled && userCountry === 'CN' ? (
					<StoreLocatorBaidu
						listProps={{ itemHeight: 300 }}
						coordinates={lat && lng ? { lat: parseFloat(lat), lng: parseFloat(lng) } : null}
						storeId={store}
					/>
				) : (
					<StoreLocator
						listProps={{ itemHeight: 300 }}
						coordinates={lat && lng ? { lat: parseFloat(lat), lng: parseFloat(lng) } : null}
						storeId={store}
					/>
				)
			case 'columns':
				return baiduEnabled && userCountry === 'CN' ? (
					<StoreLocatorBaidu
						listProps={{ itemHeight: 300 }}
						coordinates={lat && lng ? { lat: parseFloat(lat), lng: parseFloat(lng) } : null}
						storeId={store}
					/>
				) : (
					<StoreLocatorColumns
						listProps={{ itemHeight: 300 }}
						coordinates={lat && lng ? { lat: parseFloat(lat), lng: parseFloat(lng) } : null}
						storeId={store}
					/>
				)
			default:
				return null
		}
	}

	return (
		<>
			{baiduEnabled && userCountry === 'CN' && (
				<Head>
					<meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests"></meta>
				</Head>
			)}
			<DynamicAreas areas={dynamicAreas} container="top" />

			<Typography variant="h1" hidden>
				<FormattedMessage id="store_locator_page_title" />
			</Typography>

			<DynamicAreas areas={dynamicAreas} container="middle" />

			{getStoreLocatorContent(template)}

			<DynamicAreas areas={dynamicAreas} container="bottom" />
		</>
	)
}

StoreLocatorPageComponent.defaultProps = {}

StoreLocatorPageComponent.propTypes = {}

export default StoreLocatorPageComponent
